import React from 'react'
import { string } from 'prop-types'
import classnames from 'classnames'

// import Relazsizes from 'relazsizes'

const TestIframe = ({ url, testName })  => {
  const isRiddle = /riddle/.test(url)
  const riddleId = isRiddle ? url.substring(url.lastIndexOf('/') + 1) : null
  const getEmbedRiddleFiles = () => (
    <>
      <script src="https://www.riddle.com/files/js/embed.js"/>
      <link href="https://www.riddle.com/files/css/embed.css" rel="stylesheet"/>
    </>
  )

  return (
    <div
      className={classnames('test-detail-iframe', {
        riddle_target: isRiddle,
      })}
      data-rid-id={riddleId}
    >
      { isRiddle && getEmbedRiddleFiles() }
      <iframe
        className="test-detail-iframe__content"
        title={testName}
        src={url}
      />
      <style jsx>
        {`
          .test-detail-iframe {
            width: 100%;
            max-width: 640px;
            margin: 0 auto;
            &__content {
              width: 100%;
              height: 768px;
              padding-top: 80px;

              position: static;

              border: none;
              border-bottom: ${isRiddle ? 'solid 1px #cfcfcf !important' : 'none'};
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  )
}

TestIframe.propTypes = {
  testName: string,
  url: string,
}

export default TestIframe
